import { axios } from '@/utils/request'

export default {
  createCategory(input){
    return axios.post('/api/services/app/Good/CreateCategory',input)
  },
  deleteCategory(id){
    return axios.delete('/api/services/app/Good/DeleteCategory?Id='+id)
  },
  getCategory(){
    return axios.get('/api/services/app/Good/GetCategory')
  },
  create(input){
    return axios.post('/api/services/app/Good/Create',input)
  },
  delete(id){
    return axios.delete('/api/services/app/Good/Delete?Id='+id)
  },
  get(id){
    return axios.get('/api/services/app/Good/Get?Id='+id)
  },
  getAll(input){
    return axios.get('/api/services/app/Good/GetAll',{params:input})
  },
  update(input){
    return axios.put('/api/services/app/Good/Update',input)
  }
}